import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'catalog',
  templateUrl: 'catalog.template.html',
  styleUrls: ['catalog.scss'],
})
export class CatalogComponent {
  constructor() {}
}
